// extracted by mini-css-extract-plugin
module.exports =  {"address":"mPvUc52Uu9BNyhTbuZm0","addressGroup":"OfLHCEdGcgZJwFvGTb9Q","alert":"pIrxax08vL0g5AntIFUQ","checkbox":"c0NeULShAHECZFnFuvam"};